import React, { useEffect, useState, useContext } from 'react'
import pclnRequest from '@pcln/request'

import { BootstrapData, Webstats, Referral } from '../../../../types'
import { BootstrapDataContext } from '../../../contexts'

import { buildHotelInventoryRequest, buildItineraryDetailsRequest, buildRCInventoryRequest } from './crossSellUtils'
import {
  Booking,
  CarInventory,
  CarInventoryParams,
  HotelInventory,
  HotelInventoryParams,
  HotelItineraryDetails,
  Product
} from './types'

async function getHotelItineraryDetails (offerToken: string): Promise<HotelItineraryDetails> {
  const itineraryResponse = await pclnRequest(buildItineraryDetailsRequest(offerToken, 'AES'))
  const { data: { itineraryDetails = {} } } = itineraryResponse.data
  const { hotelXsellCarousel } = itineraryDetails
  return hotelXsellCarousel
}

export default function useCrossSellInventory (booking: Booking, productType?: Product): HotelInventory | CarInventory | null {
  const [data, setData] = useState({})
  const {
    isMobile = false,
    referral,
    webstats
  }: {
    isMobile: boolean
    referral: Referral,
    webstats: Webstats
  } = useContext(BootstrapDataContext) as BootstrapData
  const cguid: string = webstats.clientGUID

  const {
    destinationCity: pickupLocation,
    travelEndDateTime: returnDateTime,
    travelStartDateTime: pickupDateTime,
    secureToken: offerToken
  } = booking

  if (!offerToken) {
    return data
  }

  useEffect(() => {
    async function getXSell () {
      try {
        const CarInventoryParams: CarInventoryParams = {
          pickupDateTime,
          returnDateTime,
          pickupLocation,
          returnLocation: pickupLocation,
          offerToken,
          tokenType: 'AES'
        }

        let hotelItineraryDetails
        if (productType !== Product.Hotel) {
          hotelItineraryDetails = await getHotelItineraryDetails(offerToken)
        }

        const requestOptions = productType === Product.Hotel ?
          buildRCInventoryRequest(CarInventoryParams) :
          buildHotelInventoryRequest({
            ...hotelItineraryDetails,
            appc: isMobile ? 'MOBILE' : 'DESKTOP',
            rid: referral.id as string,
            productId: productType,
            pageSize: isMobile ? 2 : 3,
            dealTypes: false,
            cguid
          } as HotelInventoryParams)

        const response = await pclnRequest(requestOptions)
        const { data: { integratedListings, rcXsell } } = response.data

        /**
         * rcXsell can potentially be null, this the reason for the null return type at function definition
         *
         * falsey return values can be
         *
         * rcXsell: null
         * "integratedListings": {
         *    "listings": []
         *  }
         */

        if (productType === Product.Hotel) {
          setData(rcXsell)
        } else {
          setData(integratedListings)
        }

      } catch (e) {
        console.log('Failed to load inventory ')
      }
    }

    getXSell()
  }, [])

  return data
}
